module.exports = __webpack_public_path__ + "img/itunes-store.aaa7fced.svg";